import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { NotificationService } from 'src/app/Service/notification.service';

import { OtherService } from 'src/app/Service/other.service';

import axios from 'src/app/Service/axios';

import { Meta } from '@angular/platform-browser';

declare let $: any;

@Component({

  selector: 'app-emdadran-business',

  templateUrl: './emdadran-business.component.html',

  styleUrls: ['./emdadran-business.component.css']

})

export class EmdadranBusinessComponent implements OnInit {

  modal_Title: string = '';

  tempStrMobile: string | number;

  lst_State: any = [];

  lst_City: any = [];

  lst_Group: any = [];

  lst_SubGroup: any = [];

  lst_Result: any = [];

  lst_Search: any = [];

  lst_Resume: any = [];

  lst_Expertise: any = [];

  showCustom_Map: boolean = false;

  showCustom_Map2: boolean = false;

  editMode: boolean = false;

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strState: new FormControl('-1'),

    strCityCode: new FormControl('-1'),

    iResume_Category: new FormControl('-1'),

    iResume_SubCategory: new FormControl('-1'),

    iPublish: new FormControl(-1),

    bPublish: new FormControl(true),

    iVIP: new FormControl(-1),

    bVIP: new FormControl(false),

  })

  mdl_Request: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iTaxiLon_User: new FormControl(''),

    strCityCode: new FormControl(-1, Validators.required),

    strState: new FormControl(-1, Validators.required),

    strTitle: new FormControl('', Validators.required),

    strMobile: new FormControl('', Validators.required),

    strAddress: new FormControl('', Validators.required),

    fLat: new FormControl(0, Validators.required),

    fLon: new FormControl(0, Validators.required),

    strWebsite: new FormControl(''),

    iResume_Category: new FormControl(-1),

    iResume_SubCategory: new FormControl(-1),

    strCV: new FormControl('', Validators.required),

    strTel: new FormControl(''),

    strWhatsUp: new FormControl(''),

    strTelegram: new FormControl(''),

    strInstagram: new FormControl(''),

    strWeekDays: new FormControl('شنبه تا پنچ شنبه', Validators.required),

    strHoursOperation: new FormControl('9:00 الی 17:00', Validators.required),

    strEmail: new FormControl(''),

    strFacebook: new FormControl(''),

    strValidityDate: new FormControl(''),

    bPublish: new FormControl(false),

    bValid: new FormControl(false),

    bVIP: new FormControl(false),

  });

  mdl_Resume: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iTaxiLon_User: new FormControl('', Validators.required),

    iResume_Gallery: new FormControl(''),

    strComment: new FormControl(''),

    strImage: new FormControl('', Validators.required),

    strCityCode: new FormControl(''),

    strVillageCode: new FormControl(''),

    bEdit: new FormControl(false),

  });

  mdl_Expertise: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iTaxiLon_User: new FormControl('', Validators.required),

    iResume_Category: new FormControl('-1', Validators.required),

    iResume_SubCategory: new FormControl('-1', Validators.required),

    strComment: new FormControl(''),

    lstmdlResume_Expertise_4Save: new FormControl(''),

  });

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private metaService: Meta

  ) { }

  ngOnInit(): void {

    this.getState();

    this.getGroup();

    this.getResult();

  }

  async getState() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`TaxiLon_State_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_State = res;


  }

  async getGroup() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Resume_Category_List4Resume`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Group = res;


  }

  async getCity(id) {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`TaxiLon_City_List4State?strState=${id}`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_City = res;



  }

  async getSubGroup(id) {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Resume_SubCategory_List4Resume?iResume_Category=${id}`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_SubGroup = res;


  }

  async getResult() {

    this.mdl_Search.patchValue({

      iPublish: !this.mdl_Search.get('bPublish')?.value ? -1 : 1,

      iVIP: !this.mdl_Search.get('bVIP')?.value ? -1 : 1,

    })

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Resume_ORG_Search`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('نشست کاربری شما منقضی شده است');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '1xzOPwZ' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Result = res;

    this.lst_Search = res;



  }

  filter_list(val: any) {

    this.lst_Result = this.lst_Search.filter((el: any) => {

      return el.strTitle.includes(val.value) ||

        el.strCityName.includes(val.value) ||

        el.strVIP.includes(val.value) ||

        el.strStateName.includes(val.value) ||

        el.strPublish.includes(val.value) ||

        el.strResume_SubCategory_strComment.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Result = this.lst_Search;

    }

  }

  async add_Business(strMode: 'Add' | 'Edit' | 'View' = 'Add', item: any = {}) {

    if (strMode == 'Add') {

      this.modal_Title = 'افزودن کسب و کار';

      this.mdl_Request.enable();

      this.lst_City = [];

      this.lst_SubGroup = [];

      this.lst_Resume = [];

      this.lst_Expertise = [];

      this.mdl_Request.patchValue({

        iTaxiLon_User: '',

        strCityCode: -1,

        strState: -1,

        strTitle: '',

        strMobile: '',

        strAddress: '',

        fLat: 0,

        fLon: 0,

        strWebsite: '',

        iResume_Category: -1,

        iResume_SubCategory: -1,

        strCV: '',

        strTel: '',

        strWhatsUp: '',

        strTelegram: '',

        strInstagram: '',

        strWeekDays: 'شنبه تا پنج شنبه',

        strHoursOperation: '9:00 الی 17:00',

        strEmail: '',

        strFacebook: '',

        strValidityDate: '',

        bPublish: false,

        bValid: false,

        bVIP: false,

      });

      this.editMode = false;

      this.showCustom_Map = false;

      setTimeout(() => {

        this.showCustom_Map = true;

      }, 10);

      $("#Add_Business").modal('show');

    }

    if (strMode == 'Edit') {

      this.editMode = true;

      this.modal_Title = 'ویرایش کسب و کار';

      this.mdl_Request.enable();

      this.lst_City = [];

      this.lst_SubGroup = [];

      Object.keys(item).forEach(key => {

        this.mdl_Request.get(key)?.setValue(item[key])

      });

      // console.log(this.mdl_Request.value)

      this.showCustom_Map = false;

      setTimeout(() => {

        this.showCustom_Map = true;

      }, 10);

      this.getSubGroup(item.iResume_Category);

      this.getCity(item.strState);

      // دریافت رزمه کسب و کار

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`Resume_ORG_Gallery_List`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());

      this._otherService.nonespinner();

      this.lst_Resume = res;

      this.getExpertise();

      // console.log(res)

      $("#Add_Business").modal('show');


    }

    if (strMode == 'View') {

      this.editMode = false;

      this.modal_Title = 'مشاهده کسب و کار';

      this.mdl_Request.disable();

      this.lst_City = [];

      this.lst_SubGroup = [];

      Object.keys(item).forEach(key => {

        this.mdl_Request.get(key)?.setValue(item[key])

      })

      this.showCustom_Map = false;

      setTimeout(() => {

        this.showCustom_Map = true;

      }, 10);

      this.getSubGroup(item.iResume_Category);

      this.getCity(item.strState);

      // دریافت رزمه کسب و کار

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`Resume_ORG_Gallery_List`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());

      this._otherService.nonespinner();

      this.lst_Resume = res;

      this.getExpertise();

      $("#Add_Business").modal('show');


    }

  }

  submitData(value: any) {

    // اگر کاربر متنی را به آدرس اضافه کرد

    if (value.isChanged == true) {

      this.mdl_Request.controls['strAddress'].setValue(value.strText);

    }

    // اگر کاربر از روی نقشه موقعیت را انتخاب کرد

    else {

      this.mdl_Request.controls['fLat'].setValue(value.latitude);

      this.mdl_Request.controls['fLon'].setValue(value.longitude);

      this.mdl_Request.controls['strAddress'].setValue(value.strText_Toolbar);

      // Rerender custom-map

      this.showCustom_Map = false;

      setTimeout(() => {

        this.showCustom_Map = true;

      }, 10);

    }

  }

  handlePaste(event: ClipboardEvent) {

    setTimeout(() => {

      this.checkMobile();

    }, 50);

  }

  async checkMobile() {

    if (this.mdl_Request.get('strMobile')?.value != '' && this.mdl_Request.get('strMobile')?.value.length == 11) {

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`Resume_ORG_Info`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());

      let item = res[0];

      this._otherService.nonespinner();

      this.tempStrMobile = this.mdl_Request.get('strMobile')?.value;

      if (res.length) {

        Object.keys(item).forEach(key => {

          this.mdl_Request.get(key)?.setValue(item[key])

        })

        this.getSubGroup(item.iResume_Category);

        this.getCity(res[0].strState);

        this.showCustom_Map = false;

        this.editMode = true;

        setTimeout(() => {

          this.showCustom_Map = true;

        }, 10);

        // دریافت رزمه کسب و کار

        this._otherService.Showspinner();

        let res_2 = JSON.parse((await axios.post(`Resume_ORG_Gallery_List`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());

        this._otherService.nonespinner();

        this.lst_Resume = res_2;

        this.getExpertise();

      }

      else {

        this.mdl_Request.patchValue({

          iTaxiLon_User: '',

          iUserManager_User: '',

          strState: -1,

          strCityCode: -1,

          strTitle: '',

          strAddress: '',

          fLat: 0,

          fLon: 0,

          strWebsite: '',

          iResume_Category: -1,

          iResume_SubCategory: -1,

          strCV: '',

          strTel: '',

          strWhatsUp: '',

          strTelegram: '',

          strInstagram: '',

          strWeekDays: 'شنبه تا پنچ شنبه',

          strHoursOperation: '9:00 الی 17:00',

          strEmail: '',

          strFacebook: '',

          strValidityDate: '',

          bPublish: false,

          bValid: false,

          bVIP: false,

        })

        this.lst_City = [];

        this.lst_SubGroup = [];

        this.lst_Resume = [];

        this.lst_Expertise = [];

        this.editMode = false;

        this.showCustom_Map = false;

        setTimeout(() => {

          this.showCustom_Map = true;

        }, 10);

      }

    }

  }

  async submit_Request() {

    let model = this.mdl_Request.value;

    if (this.mdl_Request.invalid) return this._tooltip.showError('فرم را با دقت تکمیل کنید!');

    if (model.strMobile.trim() == '' || model.strMobile.length != 11) return this._tooltip.showError('شماره موبایل را یه درستی وارد کنید');

    if (model.strCityCode == -1 || model.strState == -1) return this._tooltip.showError('استان, شهر را انتخاب کنید');

    if (model.iResume_Category == -1 || model.iResume_SubCategory == -1) return this._tooltip.showError('گروه, زیر گروه را انتخاب کنید');

    if (model.fLat == 0 || model.fLon == 0) return this._tooltip.showError('موقعیت را از روی نقشه انتخاب کنید!');

    else {

      // ویرایش کسب و کار

      if (this.editMode || this.mdl_Request.get('iTaxiLon_User')?.value != '') {

        $.confirm({

          title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

          content: '',

          type: 'blue',

          buttons: {

            ok: {

              text: "ویرایش",

              btnClass: 'btn-primary',

              keys: ['enter'],

              action: async () => {

                this._otherService.Showspinner();

                let res = JSON.parse((await axios.post(`resume_ORG_Edit`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());

                this._otherService.nonespinner();

                const found = this.lst_Result.find(({ iTaxiLon_User }) => iTaxiLon_User == res[0].iTaxiLon_User);

                this.lst_Result[this.lst_Result.indexOf(found)] = res[0];

                if (res.iResult == 0) return this._tooltip.showError(res.strError);

                this._tooltip.showSuccess('با موفقیت ویرایش شد');


              }

            },

            cancel: {

              text: "لغو",

            }

          }

        });

        // 

      }

      // افزودن کسب و کار

      else {

        this._otherService.Showspinner();

        let res = JSON.parse((await axios.post(`Resume_ORG_Save`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());

        this._otherService.nonespinner();

        if (res.iResult == 0) return this._tooltip.showError(res.strError);

        this.lst_Result.push(res[0]);

        this.mdl_Request.get('iTaxiLon_User')?.setValue(res[0].iTaxiLon_User);

        this.editMode = true;

        this._tooltip.showSuccess('با موفقیت ثبت شد');

      }

    }

  }

  async remove_Business(item, index: number) {

    $.confirm({

      title: `آیا از حذف کسب و کار اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this._otherService.Showspinner();

            let res = JSON.parse((await axios.post(`Resume_ORG_Delete`, this._otherService.stringNumberToNumber({ ...this.mdl_Search.value, iTaxiLon_User: item.iTaxiLon_User }))).data.toString());

            this._otherService.nonespinner();

            if (res.iResult == 0 && res.strError != '') return this._tooltip.showError(res.strError);

            this.lst_Result.splice(index, 1);

            this._tooltip.showSuccess('با موفقیت حذف شد');

          }

        },

        cancel: {

          text: "لغو",


        }

      }

    });

  }

  open_Location(item) {

    Object.keys(item).forEach(key => {

      this.mdl_Request.get(key)?.setValue(item[key])

    });

    this.showCustom_Map2 = false;

    setTimeout(() => {

      this.showCustom_Map2 = true;

    }, 10);


  }

  add_Resume() {

    if (this.mdl_Request.get('iTaxiLon_User')?.value == '') return this._tooltip.showError('ابتدا کسب و کار خود را ثبت کنید!');

    this.mdl_Resume.patchValue({

      bEdit: false,

      iTaxiLon_User: this.mdl_Request.get('iTaxiLon_User')?.value,

      iResume_Gallery: '',

      strCityCode: '',

      strVillageCode: '',

      strComment: '',

      strImage: '',


    })

    $("#Add_Resume").modal('show');


  }

  onFileInput(file: any) {

    let extension = file.name.split('.').pop();

    if (extension !== 'jpeg' && extension !== 'jpg') this._tooltip.showError(' فرمت قابل قبول فقط jpg است')

    if (extension === 'jpeg' || extension === 'jpg') {

      const reader: any = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = async () => {

        var base64String = reader.result.toString();

        this.mdl_Resume.patchValue({

          strImage: base64String.replace('data:image/jpeg;base64,', ''),

        })

      };

    }

  }

  async submit_Resume() {

    if (this.mdl_Resume.invalid) return this._tooltip.showError('تصویر و توضیحات را وارد کنید');

    if (this.mdl_Resume.get('bEdit')?.value) {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              this._otherService.Showspinner();

              let res = JSON.parse((await axios.post(`Resume_Gallery_ORG_Edit`, this._otherService.stringNumberToNumber(this.mdl_Resume.value))).data.toString());

              this._otherService.nonespinner();

              if (res.iResult == 0 && res.strError != '') return this._tooltip.showError(res.strError);

              this._tooltip.showSuccess('با موفقیت ویرایش شد');

              this._otherService.Showspinner();

              let res_2 = JSON.parse((await axios.post(`Resume_ORG_Gallery_List`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());

              this._otherService.nonespinner();

              this.lst_Resume = res_2;

              $("#Add_Resume").modal('hide');

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

    else {

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`Resume_Gallery_ORG_Save`, this._otherService.stringNumberToNumber(this.mdl_Resume.value))).data.toString());

      this._otherService.nonespinner();

      if (res.iResult == 0 && res.strError != '') return this._tooltip.showError(res.strError);

      this._tooltip.showSuccess('با موفقیت ثبت شد');

      this._otherService.Showspinner();

      let res_2 = JSON.parse((await axios.post(`Resume_ORG_Gallery_List`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());

      this._otherService.nonespinner();

      this.lst_Resume = res_2;

      $("#Add_Resume").modal('hide');

    }

  }

  edit_Resume(item, index: number) {

    this.mdl_Resume.patchValue({

      bEdit: true,

      iTaxiLon_User: item.iTaxiLon_User,

      iResume_Gallery: item.iResume_Gallery,

      strCityCode: '',

      strVillageCode: '',

      strComment: item.strComment,

      strImage: item.strImage,


    })

    $("#Add_Resume").modal('show');

  }

  remove_Resume(item, index: number) {

    $.confirm({

      title: `آیا از حذف اطلاعات اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            let model = this._otherService.stringNumberToNumber({ ...this.mdl_Resume.value, iResume_Gallery: item.iResume_Gallery });

            this._otherService.Showspinner();

            let res = JSON.parse((await axios.post(`Resume_Gallery_ORG_Delete`, model)).data.toString());

            this._otherService.nonespinner();

            if (res.iResult == 0 && res.strError != '') return this._tooltip.showError(res.strError);

            this._tooltip.showSuccess('با موفقیت حذف شد');

            this.lst_Resume.splice(index, 1);

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

    // 

  }

  add_Expertise() {

    if (this.mdl_Request.get('iTaxiLon_User')?.value == '') return this._tooltip.showError('ابتدا کسب و کار خود را ثبت کنید!');

    this.mdl_Expertise.patchValue({

      iTaxiLon_User: this.mdl_Request.get('iTaxiLon_User')?.value,

      iResume_Category: -1,

      iResume_SubCategory: -1,

      strComment: ''

    })

    $("#Add_Expertise").modal('show');

  }

  async submit_Expertise() {

    let model = this.mdl_Expertise.value;

    if (this.mdl_Expertise.invalid) return this._tooltip.showError('فرم را با دقت تکمیل کنید!');

    if (model.iResume_Category == -1 || model.iResume_SubCategory == -1) return this._tooltip.showError('گروه, زیر گروه را انتخاب کنید');

    else {

      this.lst_Expertise.push({

        iResume_Category: model.iResume_Category,

        iResume_SubCategory: model.iResume_SubCategory,

        strComment: model.strComment

      })

      model.lstmdlResume_Expertise_4Save = this.lst_Expertise;

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`Resume_Expertise_Edit`, this._otherService.stringNumberToNumber(model))).data.toString());

      this._otherService.nonespinner();

      if (res.ISSessionExpired == true) {

        $("#Add_Business").modal('hide');

        $("#Add_Expertise").modal('hide');

        this._tooltip.showError('نشست کاربری شما منقضی شده است');

        setTimeout(() => {

          this._otherService.removeLocalStorage();

          this.router.navigate(['login'], { queryParams: { error: '1xzO76PwZ' } });

        }, 10);

        return;

      }

      if (res.iResult == 0 && res.strError != '') {

        this.getExpertise();

        return this._tooltip.showError(res.strError);

      }

      this._tooltip.showSuccess('با موفقیت ثبت شد');

      this.getExpertise();

      $("#Add_Expertise").modal('hide');

    }

  }

  remove_Expertise(item, index: number) {

    $.confirm({

      title: `آیا از حذف اطلاعات اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            let model = this.mdl_Expertise.value;

            this.lst_Expertise.splice(index, 1);

            model.iTaxiLon_User = this.mdl_Request.get('iTaxiLon_User')?.value;

            model.lstmdlResume_Expertise_4Save = this.lst_Expertise;

            this._otherService.Showspinner();

            let res = JSON.parse((await axios.post(`Resume_Expertise_Edit`, this._otherService.stringNumberToNumber(model))).data.toString());

            this._otherService.nonespinner();

            if (res.ISSessionExpired == true) {

              $("#Add_Business").modal('hide');

              $("#Add_Expertise").modal('hide');

              this._tooltip.showError('نشست کاربری شما منقضی شده است');

              setTimeout(() => {

                this._otherService.removeLocalStorage();

                this.router.navigate(['login'], { queryParams: { error: '1xzO76PwZ' } });

              }, 10);

              return;

            }

            if (res.iResult == 0 && res.strError != '') {

              this.lst_Expertise.push(item);

              return this._tooltip.showError(res.strError);

            }

            this._tooltip.showSuccess('با موفقیت حذف شد');

            $("#Add_Expertise").modal('hide');

            this.getExpertise();

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  async getExpertise() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Resume_ORG_Expertise_List`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Expertise = res;

  }

}
